import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { routes } from '../utils/mockData';

const { FiMapPin, FiClock, FiCheckCircle } = FiIcons;

const RouteStrip = ({ route, delay }) => {
  const isDelayed = route.status === 'delayed';
  const color = isDelayed ? '#ff5500' : '#00f0ff';
  
  return (
    <motion.div 
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay }}
      className={`hud-panel p-5 relative overflow-hidden ${isDelayed ? 'border-[#ff5500]/30' : 'hover:border-[#00f0ff]/30'} transition-all`}
    >
      {/* Background Progress Bar */}
      <div 
        className="absolute top-0 left-0 h-full opacity-[0.03] transition-all duration-1000"
        style={{ width: `${route.progress}%`, backgroundColor: color }}
      />

      <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex-shrink-0 w-32">
          <h3 className="text-xl font-bold font-mono text-gray-200">{route.id}</h3>
          <p className="text-[10px] font-mono text-gray-500 uppercase">Unit: <span className="text-gray-300">{route.vehicleId}</span></p>
        </div>

        <div className="flex-1 w-full">
          <div className="flex justify-between text-[10px] font-mono mb-2 uppercase tracking-widest">
            <span className="text-gray-400">Progress: {route.completed}/{route.stops} Stops</span>
            <span className={isDelayed ? 'text-[#ff5500]' : 'text-[#00f0ff]'}>{route.progress}%</span>
          </div>
          
          <div className="relative h-2 bg-[#1a1a2e] rounded-full w-full">
            <div 
              className="absolute top-0 left-0 h-full rounded-full transition-all duration-1000"
              style={{ width: `${route.progress}%`, backgroundColor: color, boxShadow: `0 0 10px ${color}` }}
            />
            {/* Stops markers */}
            {Array.from({ length: 5 }).map((_, i) => (
              <div 
                key={i} 
                className="absolute top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-[#0a0a12] border border-gray-600"
                style={{ left: `${(i + 1) * 20}%` }}
              />
            ))}
          </div>
        </div>

        <div className="flex-shrink-0 flex items-center gap-6 text-sm font-mono">
          <div className="flex flex-col items-end">
            <span className="text-[10px] text-gray-500 uppercase">Est. Arrival</span>
            <span className={`font-bold ${isDelayed ? 'text-[#ff5500] text-glow-orange' : 'text-gray-200'}`}>{route.eta}</span>
          </div>
          <div className={`px-3 py-1 rounded text-[10px] uppercase tracking-widest border ${isDelayed ? 'border-[#ff5500] text-[#ff5500] bg-[#ff5500]/10' : 'border-[#00f0ff] text-[#00f0ff] bg-[#00f0ff]/10'}`}>
            {route.status}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

const Routes = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-end">
        <div>
          <h1 className="text-2xl font-bold text-gray-100 tracking-wider">ACTIVE ROUTES</h1>
          <p className="text-xs font-mono text-gray-500 uppercase mt-1">Real-time vector tracking</p>
        </div>
        <button className="flex items-center gap-2 bg-[#00f0ff]/10 hover:bg-[#00f0ff]/20 text-[#00f0ff] border border-[#00f0ff]/50 px-4 py-2 rounded text-[10px] font-mono uppercase tracking-widest transition-all">
          <SafeIcon icon={FiMapPin} /> Assign New Route
        </button>
      </div>

      <div className="space-y-4">
        {routes.map((route, i) => (
          <RouteStrip key={route.id} route={route} delay={i * 0.15} />
        ))}
      </div>
    </div>
  );
};

export default Routes;